import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import styles from './NotificationsPage.module.css';
import { useAuth } from '../../context/AuthContext'; // Import useAuth

const NotificationsPage = () => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { user: authUser, loading: authLoading } = useAuth(); // Get user and loading from AuthContext

    const fetchNotifications = async () => {
        try {
            setLoading(true);
            const res = await api.get('/api/notifications');
            setNotifications(res.data);
        } catch (err) {
            setError('Failed to fetch notifications');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!authLoading && authUser) { // Only fetch if AuthContext is not loading and user is authenticated
            fetchNotifications();
        } else if (!authLoading && !authUser) { // If not loading and no user, means not authenticated (or logged out)
            setLoading(false); // Stop local loading
            // Optionally, set an error message or redirect to login
            setError('Not authenticated.');
        }
    }, [authLoading, authUser]); // Add authLoading and authUser to dependency array

    const handleMarkAsRead = async (id) => {
        try {
            await api.put(`/api/notifications/read/${id}`);
            fetchNotifications(); // Re-fetch to update read status
        } catch (err) {
            console.error('Failed to mark notification as read', err);
        }
    };

    const handleMarkAllAsRead = async () => {
        try {
            // Assuming a backend endpoint to mark all as read for the user
            // If not, iterate and mark individually (less efficient)
            // For now, let's assume individual marking or a new endpoint
            const unreadNotifications = notifications.filter(n => !n.read);
            await Promise.all(unreadNotifications.map(n => api.put(`/api/notifications/read/${n._id}`)));
            fetchNotifications();
            alert('All notifications marked as read!');
        } catch (err) {
            console.error('Failed to mark all notifications as read', err);
            alert('Failed to mark all notifications as read');
        }
    };

    if (loading) {
        return <div className={styles.loading}>Loading notifications...</div>;
    }

    if (error) {
        return <div className={styles.error}>{error}</div>;
    }

    return (
        <div className={styles.notificationsPage}>
            <h2 className={styles.pageTitle}>Your Notifications</h2>
            
            <div className={styles.notificationList}>
                {notifications.length === 0 ? (
                    <p>No notifications to display.</p>
                ) : (
                    notifications.map((notification) => (
                        <div key={notification._id} className={`${styles.notificationItem} ${notification.read ? styles.read : styles.unread}`}>
                            <div className={styles.notificationHeader}>
                                <h3>{notification.title}</h3>
                            </div>
                            <p className={styles.notificationMessage}>{notification.message}</p>
                            <div className={styles.notificationFooter}>
                                {!notification.read ? (
                                    <button onClick={() => handleMarkAsRead(notification._id)} className={styles.markReadButton}>
                                        Mark as Read
                                    </button>
                                ) : (
                                    <span></span>
                                )}
                                <span className={styles.timestamp}>
                                    {new Date(notification.timestamp).toLocaleString()}
                                </span>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {notifications.length > 0 && (
                <div className={styles.markAllReadContainer}>
                    <button onClick={handleMarkAllAsRead} className={styles.markAllReadButton}>
                        Mark All as Read
                    </button>
                </div>
            )}
        </div>
    );
};

export default NotificationsPage;